class ShopifyCart {
  async clearCart() {
    await fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: "{}",
    });
  }

  async addToCart(variantId, quantity, properties = {}) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: variantId, quantity, properties }],
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add item to cart");
    }

    return response.json();
  }
}

class MetaPixelTracker {
  targetVariantId = null;

  track = (eventName, payload) => {
    const productIds = payload.items.map((item) => item.id);
    const externalTrackerPayloadDetail = {
      content_type: "product_group",
      value: payload.totalPrice,
      content_ids: productIds,
      contents: payload.items,
      num_items: payload.itemCount,
      currency: payload.currency,
    };
    const eventData = {
      eventId: payload.sessionId,
    };
    if (window.fbq) {
      window.fbq("track", eventName, externalTrackerPayloadDetail, eventData);
      console.log(
        `[Tesseract] Meta Pixel ${eventName} event sent`,
        externalTrackerPayloadDetail
      );
    }
  };

  handleInitiateCheckoutEvent = (event) => {
    try {
      if (event?.detail?.data?.items === undefined) {
        return;
      }
      // this.track("InitiateCheckout", event.detail.data);
      const externalTrackerPayload = event.detail.data;
      if (
        this.targetVariantId !== null &&
        (externalTrackerPayload.items.some(
          (item) => item.variant === this.targetVariantId
        ) ||
          false)
      ) {
        console.log(
          "[Tesseract] Skipping InitiateCheckout event for target variant"
        );
        return;
      }
      this.track("InitiateCheckout", externalTrackerPayload);
    } catch (error) {
      console.error(
        "[Tesseract] Error handling initiate checkout info event:",
        error
      );
    }
  };

  handleAddPaymentInfoEvent = (event) => {
    try {
      if (event?.detail?.data?.items === undefined) {
        return;
      }
      // this.track("AddPaymentInfo", event.detail.data);
      const externalTrackerPayload = event.detail.data;
      if (
        this.targetVariantId !== null &&
        (externalTrackerPayload.items.some(
          (item) => item.variant === this.targetVariantId
        ) ||
          false)
      ) {
        console.log(
          "[Tesseract] Skipping AddPaymentInfo event for target variant"
        );
        return;
      }
      this.track("AddPaymentInfo", externalTrackerPayload);
    } catch (error) {
      console.error(
        "[Tesseract] Error handling add payment info event:",
        error
      );
    }
  };

  handlePurchaseEvent = (event) => {
    try {
      if (event?.detail?.data?.items === undefined) {
        return;
      }
      const externalTrackerPayload = event.detail.data;
      if (
        this.targetVariantId !== null &&
        (externalTrackerPayload.items.some(
          (item) => item.variant === this.targetVariantId
        ) ||
          false)
      ) {
        this.track("Mediabuy", externalTrackerPayload);
      } else {
        this.track("Purchase", externalTrackerPayload);
      }
    } catch (error) {
      console.error("[Tesseract] Error handling purchase event:", error);
    }
  };

  listen() {
    window.addEventListener(
      "breeze-initiate-checkout",
      this.handleInitiateCheckoutEvent
    );
    window.addEventListener(
      "breeze-add-payment-info",
      this.handleAddPaymentInfoEvent
    );
    window.addEventListener("breeze-purchase", this.handlePurchaseEvent);
  }
}

class Tesseract {
  constructor() {
    this.shopify = new ShopifyCart();
    this.metaPixel = new MetaPixelTracker();
    this.metaPixel.listen();
  }

  async buyNow(variantId, quantity = 1, properties = {}) {
    try {
      if (!window.breeze || !window.breeze.startCheckout) {
        throw new Error("Breeze checkout is not available");
      }

      this.metaPixel.targetVariantId = variantId;
      await this.shopify.clearCart();
      await this.shopify.addToCart(variantId, quantity, properties);
      window.breeze.startCheckout();
      return true;
    } catch (error) {
      console.error("[Tesseract] Buy Now failed:", error);
      return false;
    }
  }
}

if (typeof window.tesseract === "undefined") {
  try {
    window.tesseract = new Tesseract();
    console.log("[Tesseract] Initialized");
  } catch (error) {
    console.error("[Tesseract] Initialization failed:", error);
  }
}
